'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckIcon = function CheckIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M26.63296,4.17664 C26.19904,3.8704 25.60096,3.97504 25.29568,4.408 L11.07232,24.59488 L5.63872,19.16224 C5.26432,18.78688 4.65568,18.78688 4.28128,19.16224 C3.90592,19.53856 3.90592,20.14528 4.28128,20.51968 L10.52128,26.75968 C10.70176,26.94016 10.94656,27.04096 11.2,27.04096 C11.50528,27.04096 11.80192,26.89408 11.98432,26.63392 L26.86432,5.51392 C27.1696,5.08 27.06592,4.48096 26.63296,4.17664 L26.63296,4.17664 Z' })
  );
};

CheckIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = CheckIcon;